export default __webpack_public_path__ + "static/media/sidebar-open.9697c236.svg";